import { render } from "./LoginTakeAway.vue?vue&type=template&id=2bdb426c&scoped=true"
import script from "./LoginTakeAway.vue?vue&type=script&lang=js"
export * from "./LoginTakeAway.vue?vue&type=script&lang=js"

import "./LoginTakeAway.vue?vue&type=style&index=0&id=2bdb426c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bdb426c"]])

export default __exports__